module.exports = __webpack_public_path__ + "img/si.493fc415.svg";